<ng-container *ngIf="operationQState$ | async as operation" [xOperation]="operation">
  <x-shop-layout *ngIf="subscriber$ | async as subscriber">
    <x-shop-header *xResponsiveIf="{ min: 'LG' }" headerStyle="custom">
      <x-header-layout containerSize="container-full">
        <x-brand-logo xHeading xGoHomeLink></x-brand-logo>
        <a xGoHomeLink mat-button xActionRight>
          <fa-icon icon="chevron-left"></fa-icon>
          <ng-container i18n="@@CallToAction.BackToShop">Back to Shop</ng-container>
        </a>
      </x-header-layout>
    </x-shop-header>
    <div xBody>
      <x-subscriber-checkout-header
        [subscriber]="subscriber"
        class="py-lg-3 mb-3 mb-lg-4"
      ></x-subscriber-checkout-header>

      <div class="container">
        <div class="row">
          <x-page-panel class="col-lg-8 pb-4" [panelLoading]="operation.status === 'loading'">
            <ng-container
              *ngTemplateOutlet="
                InvalidRequirementTranslation;
                context: { requirement: (userAddressRequirements$ | async) }
              "
            ></ng-container>
            <!--delivery address-->
            <x-address-book
              *ngIf="user$ | async as user"
              i18n-heading="@@AddressBook.Heading"
              heading="Delivery Addresses"
              [hasNotification]="!!(userAddressRequirements$ | async)"
              [user]="user"
              [defaultCountry]="(subscriberChannel$ | async)?.defaultCountry"
              [restrictedRegions]="(channelRegionIds$ | async) ?? []"
              [addresses]="(userAddressesByCountry$ | async) ?? []"
              (addressCreated)="addressCreated($event)"
              (addressSelected)="addressSelected($event)"
              (addressUpdated)="addressUpdated($event)"
              (addressDeleted)="addressDeleted($event)"
              [selectedAddressHash]="subscriber.shippingAddress?.hash"
              i18n-addressTooltip="@@Tooltip.AssignAddress"
              addressTooltip="Assign address"
              [disableAddressActions]="operation.error !== undefined"
            >
              <ng-container
                xRequirementNotification
                *ngTemplateOutlet="
                  RequirementTranslation;
                  context: { requirement: (userAddressRequirements$ | async) }
                "
              ></ng-container>
            </x-address-book>

            <!--payment details-->

            <div class="mt-4">
              <ng-container
                *ngTemplateOutlet="
                  InvalidRequirementTranslation;
                  context: { requirement: (userPaymentMethodRequirements$ | async) }
                "
              ></ng-container>

              <x-page-panel i18n-heading="@@PaymentDetails.Heading" heading="Payment Details">
                <ng-container *ngIf="userPaymentMethods$ | async as userPaymentMethods">
                  <ng-container
                    *ngTemplateOutlet="
                      RequirementTranslation;
                      context: { requirement: (userPaymentMethodRequirements$ | async) }
                    "
                  ></ng-container>
                  <x-banner-button-group *ngIf="userPaymentMethods.length">
                    <x-banner-button
                      *ngFor="let userPaymentMethod of userPaymentMethods; trackBy: 'id' | trackBy"
                      (click)="setPaymentMethod(userPaymentMethod)"
                      [active]="subscriber.userPaymentMethod?.id === userPaymentMethod.id"
                      [radioButton]="true"
                    >
                      <div class="payment-method">
                        <div class="desc">{{ userPaymentMethod.description }}</div>
                        <div class="exp">
                          {{ userPaymentMethod.expiresAt | date: 'MM/yy' }}
                        </div>
                      </div>

                      <fa-icon xIconSuffix icon="credit-card" xIconSize="large"></fa-icon>
                    </x-banner-button>
                  </x-banner-button-group>
                </ng-container>
                <button
                  mat-flat-button
                  color="accent"
                  xActionFooter
                  *ngFor="let method of paymentMethods$ | async; trackBy: 'id' | trackBy"
                  (click)="createUserPayment(method)"
                >
                  +&nbsp;
                  <ng-container i18n="@@CallToAction.AddNew">Add new</ng-container>
                </button>
              </x-page-panel>
            </div>

            <!--mobile summary accordion-->
            <mat-expansion-panel class="mt-4" *xResponsiveIf="{ max: 'LG' }">
              <mat-expansion-panel-header>
                <mat-panel-title i18n="@@ExpansionPanel.SubscriptionSummary.Label">
                  Subscription summary
                </mat-panel-title>
              </mat-expansion-panel-header>
              <x-subscriber-checkout-summary
                [subscriber]="subscriber"
              ></x-subscriber-checkout-summary>
            </mat-expansion-panel>

            <div class="mobile-footer" *xResponsiveIf="{ max: 'LG' }">
              <ng-container
                [ngTemplateOutlet]="SubscriptionAction"
                [ngTemplateOutletContext]="{ $implicit: subscriber }"
              ></ng-container>
            </div>

            <div class="mt-4 mat-display-2" *ngIf="subscriptionUrl$ | async as subscriptionUrl">
              By signing up for our {{ subscriber.subscriptionName }} you agree to our
              <a
                [routerLink]="['/' + subscriber.variantChannel + '/' + subscriptionUrl]"
                xLinkColor="default"
              >
                <ng-container i18n="@@Legal.AgreeMessage.Part2">terms and conditions</ng-container>
                .
              </a>
            </div>
          </x-page-panel>
          <x-page-panel class="col-lg-4" *xResponsiveIf="{ min: 'LG' }">
            <x-page-panel
              class="subscription-summary-panel"
              [panelLoading]="operation.status === 'loading'"
            >
              <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                  <mat-panel-title i18n="@@ExpansionPanel.SubscriptionSummary.Label">
                    Subscription summary
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <x-subscriber-checkout-summary [subscriber]="subscriber">
                  <ng-container
                    xAction
                    [ngTemplateOutlet]="SubscriptionAction"
                    [ngTemplateOutletContext]="{ $implicit: subscriber }"
                  ></ng-container>
                </x-subscriber-checkout-summary>
              </mat-expansion-panel>
              <button type="button" mat-button xButtonType="link" xNeedHelp color="primary">
                <fa-icon icon="question"></fa-icon>
                <span i18n="@@CallToAction.NeedHelp">Help</span>
              </button>
            </x-page-panel>
          </x-page-panel>
        </div>
      </div>
    </div>
  </x-shop-layout>

  <ng-template let-requirement="requirement" #InvalidRequirementTranslation>
    <ng-container *ngIf="requirement">
      <ng-container *ngIf="requirement.type === 'invalid'">
        <div class="requirement requirement-error">
          <div class="requirement-error-message">{{ requirement.message }}</div>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template let-requirement="requirement" #RequirementTranslation>
    <ng-container *ngIf="requirement">
      <ng-container *ngIf="requirement.type === 'required'">
        <div class="requirement">
          <div class="requirement-message">{{ requirement.message }}</div>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #SubscriptionAction let-subscriber>
    <!--totals-->
    <div class="totals mb-2 mb-lg-3">
      <span i18n="@@Money.Total">Total</span>
      <span class="total">
        {{ subscriber.price.amount | money: subscriber.price.currency }}
        <span class="interval">
          {{ 'SubscriptionRunIntervalUnit.' + subscriber.variantInterval | l }}
        </span>
      </span>
    </div>

    <x-subscriber-agreements
      class="mb-3"
      [agreements]="subscriber?.requiredAgreements"
    ></x-subscriber-agreements>

    <!--action-buttons-->
    <div class="active-actions d-flex gap-2" *ngIf="subscriber.state === 'ACTIVE'">
      <button
        mat-stroked-button
        color="primary"
        class="flex-fill"
        (click)="pause(operation.status)"
        [disabled]="(disableButton$ | async) ?? false"
        i18n="@@CallToAction.Pause"
      >
        Pause
      </button>

      <button
        [routerLink]="rc.redirectUrl"
        mat-flat-button
        color="primary"
        class="flex-fill"
        [disabled]="(disableButton$ | async) ?? false"
        i18n="@@CallToAction.Update"
      >
        Update
      </button>
    </div>

    <button
      *ngIf="subscriber.state !== 'ACTIVE'"
      mat-flat-button
      color="primary"
      (click)="activate(operation.status)"
      [disabled]="(disableButton$ | async) ?? false"
      xButtonSize="full"
    >
      @switch (subscriber.state) {
        @case ('CART') {
          <span i18n="@@CallToAction.Subscribe">Subscribe</span>
        }
        @default {
          <span i18n="@@CallToAction.Resubscribe">Resubscribe</span>
        }
      }
    </button>

    <!--need help-->
    <button
      *xResponsiveIf="{ max: 'LG' }"
      type="button"
      mat-button
      xButtonType="link"
      xNeedHelp
      color="primary"
      i18n="@@CallToAction.NeedHelp"
    >
      Need Help?
    </button>
  </ng-template>

  <x-shop-error-operation *xOperationError="let error" [error]="error"></x-shop-error-operation>
</ng-container>
